import { getFolderIcon } from "@/utils/getFolderIcon";

/**
 * Convert workspace structure to preview nodes format
 * @param {Array} subjects - Workspace structure
 * @returns {Array} Preview nodes for tree display
 */
export const mapToPreviewNodes = (subjects) => {
  // Determine maxDepth: 2 if any Level2 has canNotExpand, otherwise 3
  const hasCanNotExpand = subjects.some((l1) =>
    (l1.children || []).some((l2) => l2.canNotExpand)
  );
  const maxDepth = hasCanNotExpand ? 2 : 3;

  return subjects.map((subject, index) => ({
    key: `subject-${subject.id}`,
    label: subject.name || `Subject ${index + 1}`,
    icon: getFolderIcon({ hierarchyLevel: 1, maxDepth }),
    hierarchyLevel: 1,
    maxDepth,
    children: (subject.children || []).map((classItem, classIndex) => ({
      key: `class-${classItem.id}`,
      label: classItem.name || `Class ${classIndex + 1}`,
      icon: getFolderIcon({ hierarchyLevel: 2, maxDepth }),
      hierarchyLevel: 2,
      maxDepth,
      children:
        classItem.children?.map((assignment, assignmentIndex) => ({
          key: `assignment-${assignment.id}`,
          label: assignment.name || `Assignment ${assignmentIndex + 1}`,
          icon: getFolderIcon({ hierarchyLevel: 3, maxDepth }),
          hierarchyLevel: 3,
          maxDepth,
        })) || [],
    })),
  }));
};

/**
 * Generate unique ID for workspace items
 * @returns {string} Unique ID
 */
export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
};
